var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-container"},[_c('h2',[_vm._v("正在登录...")])])
}]

export { render, staticRenderFns }